import loadable from '@loadable/component';
export const UiGuide = loadable(() => import('./UiGuide'));
//# sourceMappingURL=index.js.map